'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var OPEN = exports.OPEN = 'MOBILE_SEARCH_MENU:OPEN';
var CLOSE = exports.CLOSE = 'MOBILE_SEARCH_MENU:CLOSE';
var SELECT_CATEGORY = exports.SELECT_CATEGORY = 'MOBILE_SEARCH_MENU:SELECT_CATEGORY';
var SHOW_REFINE_OPTIONS = exports.SHOW_REFINE_OPTIONS = 'MOBILE_SEARCH_MENU:SHOW_REFINE_OPTIONS';
var SELECT_REFINE_OPTION = exports.SELECT_REFINE_OPTION = 'MOBILE_SEARCH_MENU:SELECT_REFINE_OPTION';
var EXPAND_PARENT_CATEGORY = exports.EXPAND_PARENT_CATEGORY = 'MOBILE_SEARCH_MENU:EXPAND_PARENT_CATEGORY';
var LOCATION_NEAR_ME_FOUND = exports.LOCATION_NEAR_ME_FOUND = 'MOBILE_SEARCH_MENU:LOCATION_NEAR_ME_FOUND';
var CLEAR_SELECTED_MENU_ITEM = exports.CLEAR_SELECTED_MENU_ITEM = 'MOBILE_SEARCH_MENU:CLEAR_SELECTED_MENU_ITEM';
var CLEAR_SELECTED_REFINE_CATEGORY = exports.CLEAR_SELECTED_REFINE_CATEGORY = 'MOBILE_SEARCH_MENU:CLEAR_SELECTED_REFINE_CATEGORY';
var CLEAR_SELECTED_PARENT_SPECIALTY = exports.CLEAR_SELECTED_PARENT_SPECIALTY = 'MOBILE_SEARCH_MENU:CLEAR_SELECTED_PARENT_SPECIALTY';

var TOGGLE_ADVANCED_OPTIONS = exports.TOGGLE_ADVANCED_OPTIONS = 'MOBILE_SEARCH_MENU:TOGGLE_ADVANCED_OPTIONS';
var SELECT_ADVANCED_OPTION = exports.SELECT_ADVANCED_OPTION = 'MOBILE_SEARCH_MENU:SELECT_ADVANCED_OPTION';

var MobileSearchMenuActions = {
	openMobileSearchMenu: function openMobileSearchMenu() {
		return {
			type: OPEN
		};
	},
	closeTabClick: function closeTabClick() {
		return {
			type: CLOSE
		};
	},
	menuItemClick: function menuItemClick(selectedItem) {
		return {
			type: SELECT_CATEGORY,
			selectedItem: selectedItem
		};
	},
	refineChangeClick: function refineChangeClick(selectedRefineCategory) {
		return {
			type: SHOW_REFINE_OPTIONS,
			selectedRefineCategory: selectedRefineCategory
		};
	},
	selectRefineCategoryOption: function selectRefineCategoryOption(selectedOption) {
		return {
			type: SELECT_REFINE_OPTION,
			selectedOption: selectedOption
		};
	},
	expandParentCategoryOption: function expandParentCategoryOption(parentKeyword) {
		return {
			type: EXPAND_PARENT_CATEGORY,
			parentKeyword: parentKeyword
		};
	},
	locationNearMeFound: function locationNearMeFound() {
		return {
			type: LOCATION_NEAR_ME_FOUND
		};
	},
	clearSelectedMenuItem: function clearSelectedMenuItem() {
		return {
			type: CLEAR_SELECTED_MENU_ITEM
		};
	},
	clearSelectedRefineCategory: function clearSelectedRefineCategory() {
		return {
			type: CLEAR_SELECTED_REFINE_CATEGORY
		};
	},
	clearSelectedParentSpecialty: function clearSelectedParentSpecialty() {
		return {
			type: CLEAR_SELECTED_PARENT_SPECIALTY
		};
	},

	toggleAdvancedOptions: function toggleAdvancedOptions() {
		return {
			type: TOGGLE_ADVANCED_OPTIONS
		};
	},
	selectAdvancedOption: function selectAdvancedOption(option) {
		return {
			type: SELECT_ADVANCED_OPTION,
			option: option
		};
	}
};

exports.default = MobileSearchMenuActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/mobile-search-menu.js
// module id = 653
// module chunks = 0